export class SetOrganisationRoleSuccess {
  public static readonly type = '[Authorisation] SetOrganisationRoleSuccess';
  constructor(
    public readonly result: any,
    public readonly organisationId: string,
  ) {}
}
